module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1212287911)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en medarbejder for at se hvor god denne er til forskellige opgavetyper\n            ")]) : _c('employee-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185fd65c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/employeeSkills.vue
// module id = 812
// module chunks = 0